import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['selectChip', 'optionInSelect', 'railingChip', 'railingChipContent']
  static values = {
    multiselectLabel: String
  }

  connect() {
    this.updateRailingChip()
  }

  updateRailingChip() {
    const checkedInputs = this.optionInSelectTargets.filter(option => option.checked)
    const showRailingChip = checkedInputs.length > 0

    this.fillRailingChipContent(checkedInputs)

    this.handleSelectChipStyle(showRailingChip)
    this.handleRailingChipStyle(showRailingChip)
  }

  fillRailingChipContent(checkedInputs) {
    if (checkedInputs.length === 1) {
      const selectedOptionLabel = checkedInputs[0].dataset.label
      this.railingChipContentTarget.innerText = selectedOptionLabel
    } else if (checkedInputs.length > 1) {
      this.railingChipContentTarget.innerText = `${this.multiselectLabelValue} (${checkedInputs.length})`
    }
  }

  resetSelect() {
    this.railingChipTarget.classList.add('hidden')
    this.optionInSelectTargets.forEach(option => {
      option.checked = false
      option.dispatchEvent(new Event('change', { bubbles: true }))
    })
    this.handleSelectChipStyle(false)
    this.handleRailingChipStyle(false)
  }

  handleSelectChipStyle(showRailingChip) {
    this.selectChipTarget.classList.toggle('selected-railing-chip', showRailingChip)
  }

  handleRailingChipStyle(showRailingChip) {
    this.railingChipTarget.classList.toggle('hidden', !showRailingChip)
  }
}
